<script setup>
import { useQuasar } from "quasar";
import { useNuxtApp } from "#app";
import { ref, onMounted, onUnmounted } from 'vue';

const $q = useQuasar();
const { $getAccessToken,$logout } = useNuxtApp();

const logout = async () => {
  await $logout();
  navigateTo("/");
};

const darkMode = ref($q.dark.isActive);

const toggleDarkMode = () => {
  $q.dark.set(!darkMode.value);
  darkMode.value = !darkMode.value;
};

const { $profileInfo, $profileImg, $memberGroup, $fetch } =
  useNuxtApp();
const profile = ref();
const profileImg = ref();
const location = ref([]);
const storeGroups = ref([]);
const FlexsysStatus = ref(null);

usePortalPageViewTracking();

let SPIFF = ref(0);
let SPIFFSummary = ref(0);
let CaptureRate = ref(0);

const storeLoc = ref("");
let intervalId;


const updateFlexsysStatus = async () => {
  const { data } = await useApiFetch(`/api/getFlexsysStatus`);
  if (data.value === null || data.value === undefined) {
    FlexsysStatus.value = null;
    return;
  }
  FlexsysStatus.value = Number(data.value);
};

async function opticianonmounted(){const profileInfo = await $profileInfo();
  const getGroup = await $memberGroup();
  if (getGroup) {
    storeGroups.value = getGroup.value
      .filter(
        (group) =>
          group.displayName && group.displayName.startsWith("Store-"),
      )
      .map((getGroup) => getGroup.displayName)[0];
    storeLoc.value = storeGroups.value;
  }
  profile.value = profileInfo;

  location.value = await useApiFetch(
    `/api/getLocations/?StoreNoDB=${storeLoc.value}`,
  );

  await updateFlexsysStatus();



  if (location.value.data && location.value.data.speclocations) {
    SPIFF.value = location.value.data.speclocations[0].SPIFF;
    SPIFFSummary.value = location.value.data.speclocations[0].SPIFFSummary;
    CaptureRate.value = location.value.data.speclocations[0].CaptureRate;
  }

  intervalId = setInterval(updateFlexsysStatus, 30000);
}



  
onMounted(opticianonmounted);


 onUnmounted(() => {
   if (!intervalId) return;
    clearInterval(intervalId);
  });


</script>

<template>
  <q-layout :class="[darkMode ? 'bg-dark' : 'bg-cyan-1']">


    <div :class="['header-container', darkMode ? 'border-grey-6' : 'border-black']">
      <div class="left-buttons">
        <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'black'" size="1.75em"
          to="/portal" label=" Portal Home" />
        <q-btn v-if="SPIFF !== 0" no-caps flat unelevated color="transparent"
          :text-color="darkMode ? 'grey-6' : 'black'" size="1.75em" to="/portal/spiff" label="SPIFF" />
        <q-btn v-if="SPIFFSummary !== 0" no-caps flat unelevated color="transparent"
          :text-color="darkMode ? 'grey-6' : 'black'" size="1.75em" to="/portal/spiffsummary" label="SPIFF Summary" />
        <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'black'" size="1.75em"
          to="/portal/capturerate" label="Capture Rate" />
        <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'black'" size="1.75em"
          to="/portal/wip" label="Job Status" />
        <q-btn no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'black'" size="1.75em"
          to="/portal/framecatalog" label="Frame Catalog" />
        <q-btn-dropdown no-caps flat unelevated color="transparent" :text-color="darkMode ? 'grey-6' : 'brand'"
          size="1.75em" label="Training">
          <q-list>
            <q-item clickable v-close-popup>
              <q-item-section style="
                                        width: 150px;
                                        height: auto;
                                        position: relative;
                                    ">
                <q-item-label>
                  <a href="https://myapps.microsoft.com/signin/a655ab7c-44dc-4d68-a618-751f1d1839b3?tenantId=620cf8c2-311f-4648-a775-3188cd1023fe"
                    target="_blank">
                    <q-img :src="darkMode ? '/img/leonardo_logo_Dark.png' : '/img/Leonardo_logo.jpg'"
                      alt="Leonardo image" style="
                                                    width: 150px;
                                                    height: auto;
                                                    z-index: -1;
                                                " />
                  </a>
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>

      </div>
      <q-space />
      <div class="right-buttons">
        <q-chip v-if="FlexsysStatus === 1" color="green" text-color="white" icon="check">
          FLEXSYS IS UP
        </q-chip>
        <q-chip v-else-if="FlexsysStatus === 0" color="red" text-color="white" icon="close">
          FLEXSYS IS DOWN AND THEY ARE AWARE
        </q-chip>
        <q-chip v-else-if="FlexsysStatus === 2" color="orange" text-color="white" icon="warning">
          YOU MAY HAVE FLEXSYS ISSUES
        </q-chip>

        <q-btn icon="brightness_6" no-caps flat unelevated size="1.25em" @click="toggleDarkMode"
          :text-color="darkMode ? 'grey-6' : 'black'" />
        <q-btn icon="logout" no-caps flat unelevated size="1.75em" @click="logout" label="Signout"
          :text-color="darkMode ? 'grey-6' : 'black'" />
      </div>
    </div>
    <slot />
  </q-layout>
</template>



<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  border-bottom: 2px solid
}

.border-grey-6 {
  border-bottom-color: #757575;
}

.border-black {
  border-bottom-color: black;
}

.header-container .left-buttons,
.header-container .right-buttons {
  display: flex;
  align-items: center;
}

.header-container .q-btn {
  margin: 0 0px;
}

.header-container .q-space {
  flex-grow: 1;
}
</style>
